import script from "./DefSKU.vue?vue&type=script&lang=ts&setup=true"
export * from "./DefSKU.vue?vue&type=script&lang=ts&setup=true"

import "./DefSKU.vue?vue&type=style&index=0&id=584b6b24&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-584b6b24"]])

export default __exports__